module.exports = __webpack_public_path__ + "images/86cc048e8a5964a048867384dfcacfd7.svg";